import React, { useState } from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';
import Notiflix from 'notiflix';
import emailjs from '@emailjs/browser';

const Contact = () => {
  useDocTitle('Gravient Technologies | Send us a message');

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!firstName.trim()) newErrors.firstName = 'First Name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last Name is required';
    if (!email.trim()) newErrors.email = 'Email is required';
    if (!phone.trim()) newErrors.phone = 'Phone is required';
    if (!message.trim()) newErrors.message = 'Message is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearForm = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhone('');
    setMessage('');
    setErrors({});
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const btn = document.getElementById('submitBtn');
    btn.disabled = true;
    btn.innerHTML = 'Sending...';

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        { first_name: firstName, last_name: lastName, email, phone_number: phone, message },
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        btn.disabled = false;
        btn.innerHTML = 'Send Message';
        Notiflix.Report.success('Success', 'Message sent successfully!', 'Okay');
        clearForm();
      })
      .catch(() => {
        btn.disabled = false;
        btn.innerHTML = 'Send Message';
        Notiflix.Report.failure('Error', 'Something went wrong. Try again.', 'Okay');
      });
  };

  return (
    <>
      <NavBar />

      {/* Contact Section */}
      <section
        id="contact"
        className="relative w-full bg-gray-50 py-20 lg:py-28"
        style={{ marginTop: '1px' }}
      >
        <div className="container mx-auto px-4 lg:px-20 flex flex-col lg:flex-row gap-12 lg:gap-16">
          
          {/* Contact Form */}
          <form
            onSubmit={sendEmail}
            className="w-full lg:w-2/3 bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-6"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-blue-900 text-left">
              Send Us a Message
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <input
                  type="text"
                  placeholder="First Name*"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  className="w-full bg-gray-100 text-gray-800 placeholder-gray-600 p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
              </div>

              <div>
                <input
                  type="text"
                  placeholder="Last Name*"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  className="w-full bg-gray-100 text-gray-800 placeholder-gray-600 p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
              </div>

              <div>
                <input
                  type="email"
                  placeholder="Email*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-gray-100 text-gray-800 placeholder-gray-600 p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
              </div>

              <div>
                <input
                  type="tel"
                  placeholder="Phone*"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full bg-gray-100 text-gray-800 placeholder-gray-600 p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
              </div>
            </div>

            <textarea
              placeholder="Message*"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="w-full h-40 bg-gray-100 text-gray-800 placeholder-gray-600 p-4 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
            />
            {errors.message && <p className="text-red-500 text-sm mt-1">{errors.message}</p>}

            <button
              id="submitBtn"
              type="submit"
              className="w-full md:w-1/2 bg-blue-900 text-white font-bold uppercase p-4 rounded-xl hover:bg-blue-800 transition duration-300"
            >
              Send Message
            </button>
          </form>

          {/* Contact Info */}
          <div className="w-full lg:w-1/3 flex flex-col gap-6 lg:gap-10">
            <div className="bg-white rounded-2xl shadow-lg p-8 space-y-6">
              <div>
                <h3 className="text-2xl font-semibold text-blue-900">Office Address</h3>
                <p className="text-gray-600 mt-1">Sector 86, Faridabad, Haryana</p>
              </div>

              <div>
                <h3 className="text-2xl font-semibold text-blue-900">Call Us</h3>
                <p className="text-gray-600 mt-1">+91 70143 15843</p>
              </div>

              <div>
                <h3 className="text-2xl font-semibold text-blue-900">Email</h3>
                <p className="text-gray-600 mt-1">support@gravienttech.in</p>
              </div>

              <div className="flex gap-4 mt-4">
                {/* Add social icons here if needed */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Contact;
